<template>
  <GcBaseLayout
    :title="'Scheduler'"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="selectedTabIndex"
    ref="gc-base-layout"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Scheduler'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Call Schedule'"
        :secondaryLabel="undefined"
      />
    </template>

    <div class="syncfusion-poc">
      <div class="main-content" v-if="loaded">
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <div class="button-toolbar">
              <div>
                <DxButton
                  text="Add New"
                  type="default"
                  styling-mode="contained"
                  class="button-full-width margin-right-5 override-styles"
                  icon="plus"
                  @click="addNewSheduleLog()"
                  width="75"
                  :visible="getPermissionToCreate"
                />
              </div>
              <div>
                <DxButton
                  type="normal"
                  styling-mode="contained"
                  class="button-full-width override-styles"
                  icon="filter"
                  @click="openFilterPanel()"
                  width="30"
                  v-if="!showRightContainer"
                />
              </div>
            </div>
            <ejs-schedule
              :id="'ejs-schedule'"
              :height="height"
              :width="width"
              :views="views"
              :showQuickInfo="isTablet"
              :selectedDate="selectedDate"
              :eventSettings="getEventSettings"
              :popupOpen="onPopupOpen"
              :eventClick="onEventClick"
              :eventRendered="onEventRendered"
              :dragStop="onDragStop"
              :dragStart="onDragStart"
              :actionComplete="onActionComplete"
              v-if="refreshSchedule"
              ref="ejs-schedule-ref"
            ></ejs-schedule
          ></template>
          <template #rightContent>
            <gc-filter-panel
              :toolbarVisible="true"
              :toolbar="filterToolbar"
              :formItemData="filterFormItems"
              :setGridPanelFilter="setGridPanelFilter"
              :gridFoolter="false"
              :showLoading="showLoading"
              :from="'transaction-screen'"
              :isNormal="false"
              :persistenceKey="undefined"
              :key="'fp-call-schedule'"
              :overWriteClear="true"
            >
            </gc-filter-panel>
          </template>
        </gc-filter-split-view>
      </div>

      <GcPopupSchedulerCallLog
        v-if="visibleCallLog"
        :visible="visibleCallLog"
        :callback="callLogCallback"
        :displayValidationSummary="displayValidationSummary"
        :showLoading="showLoading"
        :displayServerError="displayServerError"
        :dataModel="dataModel"
        :isTablet="isTablet"
      />
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import {
  CallScheduleTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/call-schedule-tabs";
import {
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  DragAndDrop,
} from "@syncfusion/ej2-vue-schedule";

import { DataManager, ODataV4Adaptor } from "@syncfusion/ej2-data";
import { FeatureStorage, TokenStorage } from "../../_services/storage";
import { CustomerScheduleLogsService } from "../../_services/api/customers/customer-schedule-logs.service";
import appConfig from "../../app-config";

import f from "odata-filter-builder";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import { CacheService } from "../../_services/cache/cache-service";

class CustomAdaptor extends ODataV4Adaptor {
  processResponse() {
    let original = super.processResponse.apply(this, arguments);

    original.forEach((item) => {
      item.subject =
        item.CustomerName + " : " + item.CallLogCallTypeDescription;
      item.startTime = new Date(item.PlannedDate);
      item.endTime = new Date(item.startTime).addGMTHours(
        undefined,
        item.ExpectedDuration
      );
    });

    return original;
  }
}

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {},
  provide: {
    schedule: [Day, Week, WorkWeek, Month, Agenda, DragAndDrop],
  },
  data() {
    return {
      loaded: false,
      height: "auto",
      width: "100%",
      views: ["Day", "Week", "WorkWeek", "Month"],
      eventSettings: {
        dataSource: this.getDataManager,
        fields: {
          id: "Id",
          subject: { name: "subject" },
          // location: { name: "ScheduleType" },
          description: { name: "Purpose" },
          startTime: { name: "startTime" },
          endTime: { name: "endTime" },
          // recurrenceRule: { name: "ShipRegion" },
        },
        enableTooltip: true,
      },
      selectedDate: new Date(),
      visibleCallLog: false,
      dataModel: undefined,

      showLeftContainer: true,
      showRightContainer: true,

      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            // var item = document.getElementById("filter-btn");
            // item.classList.remove("dx-state-invisible");

            // setTimeout(() => {
            //   this.reSizeGrid();
            // }, 50);
          },
        },
        // filterOnEnter: this.gridToolbar.filterOnEnter
        //   ? this.gridToolbar.filterOnEnter
        //   : false,
      },
      refreshSchedule: true,
      callLogFilter: undefined,
      CustomerSalesRepresentativeCode: undefined,
    };
  },
  mounted() {
    setTimeout(() => {
      var scrollableView = document.getElementsByClassName(
        "layout-body dx-scrollview"
      );

      this.height = scrollableView[0].clientHeight - 65;
    }, 250);
  },
  computed: {
    getPermissionToCreate() {
      return FeatureStorage.checkPermission("CallSchedules", "create");
    },
    getEventSettings() {
      return {
        dataSource: this.getDataManager,
        fields: {
          id: "Id",
          subject: { name: "subject" },
          // location: { name: "ScheduleType" },
          description: { name: "Purpose" },
          startTime: { name: "startTime" },
          endTime: { name: "endTime" },
          // recurrenceRule: { name: "ShipRegion" },
        },
        enableTooltip: true,
      };
    },
    getDataManager() {
      if (this.callLogFilter == undefined) return;
      let dataManager = new DataManager({
        url:
          appConfig.VUE_APP_ROOT_API +
          `/api/CallLog?${
            this.callLogFilter
              ? `&filter=${this.callLogFilter} and (Status ne 'X')`
              : `&filter=(Status ne 'X')`
          }`,
        adaptor: new CustomAdaptor(),
        crossDomain: true,
      });

      dataManager.adaptor.beforeSend = function(dm, request) {
        request.setRequestHeader("x-tenant-id", TokenStorage.getTenant());
        request.setRequestHeader(
          "Authorization",
          `Bearer ${TokenStorage.getToken()}`
        );
      };

      return dataManager;
    },
    filterFormItems() {
      return [
        {
          screenField: "CustomerName",
          filterDataField: "CustomerSearchText",
          dataType: "string",
          type: "Text",
        },
        {
          screenField: "CustomerType",
        },
        {
          screenField: "CustomerGroup",
        },
        {
          screenField: "CustomerRep",
          filterDefaultValue: this.getCustomerRepDefault,
        },
        {
          screenField: "Market",
          filterDataField: "MarketCode",
        },
        {
          screenField: "CustomerReportingGroup1",
          filterDataField: "ReportingGroup1Code",
        },
        {
          screenField: "CustomerReportingGroup2",
          filterDataField: "ReportingGroup2Code",
        },
        {
          screenField: "CustomerReportingGroup3",
          filterDataField: "ReportingGroup3Code",
        },
      ];
    },
    getTabs() {
      return CallScheduleTabs;
    },
    selectedTabIndex() {
      return GetIndexByTabName("Schedule");
    },
    getCustomerRepDefault() {
      if (this.CustomerSalesRepresentativeCode)
        return [this.CustomerSalesRepresentativeCode];
      else return false;
    },
  },
  methods: {
    setGridPanelFilter(e, valueChanged) {
      if (e.length > 0 && (valueChanged || valueChanged == undefined)) {
        var filter = undefined;
        e.forEach((element) => {
          if (Array.isArray(element)) {
            var filt = undefined;
            element.forEach((item) => {
              if (Array.isArray(item)) {
                if (!filt) {
                  if (item[1] == "=") {
                    filt = f().eq(item[0], item[2]);
                  } else if (item[1] == "contains") {
                    filt = f()
                      .contains((x) => x.toLower(item[0]), item[2])
                      .toString();
                  }
                } else {
                  if (item[1] == "=") {
                    filt =
                      f()
                        .eq(item[0], item[2])
                        .toString() +
                      " or " +
                      filt;
                  } else if (item[1] == "contains") {
                    filt =
                      f()
                        .contains((x) => x.toLower(item[0]), item[2])
                        .toString() +
                      " or " +
                      filt;
                  }
                }
              }
            });
            if (!filter) {
              filter = `(${filt})`;
            } else {
              filter = filter + ` and (${filt})`;
            }
          }
        });

        if (filter == undefined) this.callLogFilter = false;
        else this.callLogFilter = filter;
      } else {
        if (e.length == 0 && valueChanged) this.callLogFilter = false;
      }
    },
    addNewSheduleLog() {
      let scheduleObj = document.getElementById("ejs-schedule")
        .ej2_instances[0];

      let cellData = {
        // Subject: "Review Meeting",
        data: {
          startTime: new Date(),
        },
        type: "Editor",
      };
      scheduleObj.popupOpen(cellData, "Editor");
    },
    openFilterPanel() {
      this.showRightContainer = true;
    },
    backButtonFunction() {
      return "";
    },
    async callLogCallback(refresh) {
      this.visibleCallLog = false;

      let scheduleObj = document.getElementById("ejs-schedule")
        .ej2_instances[0];

      if (refresh) scheduleObj.refresh();
    },

    async showEventCreateOrEditModal(args, eventData) {
      args.cancel = true;
      if (eventData) {
        if (eventData.RecordId && eventData.CalendarScheduleRecordID) {
          this.showLoading(true);
          await CustomerScheduleLogsService.getScheduleLogsByRecordId(
            eventData.CalendarScheduleRecordID
          )
            .then((res) => {
              this.showLoading(false);
              if (res.data.value.length > 0) {
                this.dataModel = res.data.value[0];
                this.dataModel.CallLogRecordId = eventData.RecordId;
              }

              this.visibleCallLog = true;
            })
            .catch((err) => {
              if (err) this.showLoading(false);
            });
        } else {
          if (this.getPermissionToCreate == false) args.cancel = true;
          else {
            this.dataModel = {
              StartDate: eventData.startTime,
            };
            this.visibleCallLog = true;
          }
        }
      }
    },

    async onEventClick(args) {
      if (args.name === "eventClick") {
        args.cancel = true;
        await this.showEventCreateOrEditModal(args, args.event);
      }
    },

    async onPopupOpen(args) {
      if (args.type === "Editor") {
        args.cancel = true;
        await this.showEventCreateOrEditModal(args, args.data);
      }
    },
    onEventRendered() {
      // console.log("onEventRendered ", e);
      // if (this.isReadOnly(args.data)) {
      //   args.element.classList.add("e-past-app");
      // }
    },
    onActionComplete(e) {
      if (e.requestType == "toolBarItemRendered") {
        e.items.forEach((element) => {
          if (element.text == "New Event") {
            element.visible = false;
          }
        });
      }
    },
    onDragStart(e) {
      if (this.getPermissionToCreate == false) e.cancel = true;
    },
    async onDragStop(e) {
      // if (e.requestType == "eventChange") {
      e.cancel = true;
      if (e.data) {
        this.showLoading(true);
        var model = e.data;
        // update single event
        let payload = {
          CalendarScheduleRecordID: model.CalendarScheduleRecordID,
          CallLogCallTypeCode: model.CallLogCallTypeCode,
          CallPurpose: model.CallPurpose,
          CustomerCode: model.CustomerCode,
          ExpectedDuration: model.ExpectedDuration,
          ActualDuration: 0,
          PlannedDate: new Date(model.startTime),
          RecordId: model.RecordId,
          Status: "O",
        };

        await CustomerScheduleLogsService.saveCustomerCallLogSingleEvent(
          payload
        )
          .then((res) => {
            if (res) this.showLoading(false);
            this.callLogCallback(true);
          })
          .catch((err) => {
            this.showLoading(false);

            this.displayServerError(err, "Save Failed");
          });
      }
    },

    async setDefaultCustomerRep() {
      var defaultSalesRep = CacheService.getCache(
        "UserDefaultSalesRepresentative"
      );

      if (!defaultSalesRep) {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative()
          .then((result) => {
            this.setLoading = false;
            if (result.data.value[0].SalesRepresentativeCode != "") {
              this.CustomerSalesRepresentativeCode =
                result.data.value[0].SalesRepresentativeCode;
            } else this.callLogFilter = false;

            CacheService.saveCache(
              "UserDefaultSalesRepresentative",
              result.data.value[0],
              2
            );
            this.loaded = true;
          })
          .catch((err) => {
            if (err) {
              this.setLoading = false;
              this.loaded = true;
              this.callLogFilter = false;
            }
          });
      } else {
        if (defaultSalesRep.SalesRepresentativeCode != "")
          this.CustomerSalesRepresentativeCode =
            defaultSalesRep.SalesRepresentativeCode;

        this.callLogFilter = false;

        this.setLoading = false;
        this.loaded = true;
      }
    },
  },

  async created() {
    await this.setDefaultCustomerRep();
    this.loaded = true;
  },
};
</script>

<style lang="scss">
.syncfusion-poc {
  padding: 10px;
  .main-content {
    // padding: 10px;
    background-color: white;
    .button-toolbar {
      height: 45px !important;
      padding: 10px;
      display: inline-flex;
      justify-content: space-between;
      flex-direction: row;
      width: 100%;
    }

    .split-view-toolbar {
      margin-top: unset !important;
      height: 46px !important;
      .dx-toolbar-items-container {
        height: inherit;
      }
    }

    // .e-control.e-schedule {
    //   margin-left: 10px;
    //   margin-right: 10px;
    //   margin-bottom: 10px;
    // }
  }
}

.e-quick-popup-wrapper.e-device.e-popup.e-popup-open {
  z-index: 121213;
}
</style>
